module.exports = __webpack_public_path__ + "fonts/Rubik-Medium.5bb1150.woff2";